import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegisterPart1Component } from './register-part1/register-part1.component';
import { RegisterPart2Component } from './register-part2/register-part2.component';
import { environment } from 'src/app/environments/environments';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuth, AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from "@angular/material/form-field";
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { RemoteApiService } from 'src/app/shared/services/remote-api.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthService } from '../../services/auth/auth.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import {MatIconModule} from '@angular/material/icon';
import { ToolsService } from 'src/app/shared/services/tools.service';
import { UserRoleAuthGuard } from 'src/app/core/guards/user-role-auth.guard';
import { DataAccessService } from 'src/app/shared/services/data-access.service';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import {AmazonLoginProvider, SocialAuthService, } from '@abacritt/angularx-social-login';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { DropdownModule } from 'primeng/dropdown';


import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  declarations: [
    LoginComponent,
    RegisterPart1Component,
    RegisterPart2Component,
    ForgetPasswordComponent,
  ],
  imports: [
    CommonModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    AuthenticationRoutingModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDialogModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    MatIconModule,
    InputTextModule,
  
    ListboxModule,
    DropdownModule,
    // CoreModule
    MatMenuModule,
    SocialLoginModule,
  ],
  exports: [
    MatProgressSpinnerModule
  ],
  providers : [
    RemoteApiService,
    AuthService,
    UserRoleAuthGuard,
    ToolsService,
    DataAccessService,
    AngularFireAuth,
  
    SocialAuthService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: AmazonLoginProvider.PROVIDER_ID,
            provider: new AmazonLoginProvider(
              'amzn1.application-oa2-client.7e0321969129425199f725cc59795c43'
            )
          },
          
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    } ,
   
  {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' }},
 
  ]

})
export class AuthenticationModule { }
